<template>
  <div class="layout-w">
    <div class="content-w">
      <div class="no-results">
        <div class="big-error-w" style="margin-bottom: 100px; text-align: left">
            <h4>
              Avalie o seu atendimento
            </h4>
            <form @submit.prevent="saveDepoimento">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-danger': errors.has('rate')}">
                      <label for="">Nota</label>
                      <rate :length="5"
                        id="rate" name="rate"
                        v-validate="'required'"
                        v-model="depoimento.nota" />
                      <div v-if="errors.has('rate')" class="help-block form-text text-muted form-control-feedback">
                        {{errors.first('rate')}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-danger': errors.has('descricao')}">
                      <label for="">Comentário</label>
                      <textarea
                        autofocus
                        id="descricao"
                        v-model="depoimento.descricao" 
                        class="form-control" name="descricao" 
                        placeholder="Como foi seu atendimento?">
                      </textarea>
                      <div v-if="errors.has('descricao')" class="help-block form-text text-muted form-control-feedback">
                        {{errors.first('descricao')}}
                      </div>
                    </div>
                    <hr />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 text-center">
                    <button type="submit" class="btn btn-primary">Salvar</button>
                  </div>
                </div>
            </form>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as axios from 'axios'

export default {
  created () {
    axios.get(`/depoimentos/${this.$route.query.id}`)
      .then(response => {
        this.depoimento = response.data
      })
  },
  data () {
    return {
      depoimento: {}
    }
  },
  methods: {
    saveDepoimento () {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            this.depoimento.exibeSite = true
            axios.put(`/depoimentos/${this.depoimento._id}`, this.depoimento)
              .then(response => {
                alert('Obrigado pela sua avaliação.')
                this.$router.push({name: 'Home'})
              })
          }
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/dashboard-cliente/AvaliacaoForm.vue